import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
const unknownCursorPosition = () => {
  return {
    column: 0,
    lineNumber: 1
  };
};
const getCursorPosition = editor => {
  return editor.getPosition() || unknownCursorPosition();
};
export const getLineCount = editor => {
  var _editor$getModel;
  return ((_editor$getModel = editor.getModel()) === null || _editor$getModel === void 0 ? void 0 : _editor$getModel.getLineCount()) || 1;
};
export const canCursorMoveUp = editor => {
  const cursorPosition = getCursorPosition(editor);
  const isFirstLine = (cursorPosition === null || cursorPosition === void 0 ? void 0 : cursorPosition.lineNumber) === 1;
  const isMultline = getLineCount(editor) > 1;
  return isMultline && !isFirstLine;
};
export const canMoveCursorDown = editor => {
  const cursorPosition = getCursorPosition(editor);
  const lineCount = getLineCount(editor);
  const isMultline = lineCount > 1;
  const isLastLine = (cursorPosition === null || cursorPosition === void 0 ? void 0 : cursorPosition.lineNumber) === lineCount;
  return isMultline && !isLastLine;
};
export const moveCursorUp = editor => {
  const cursorPosition = getCursorPosition(editor);
  editor.setPosition(_objectSpread(_objectSpread({}, cursorPosition), {}, {
    lineNumber: (cursorPosition === null || cursorPosition === void 0 ? void 0 : cursorPosition.lineNumber) - 1
  }));
};
export const moveCursorDown = editor => {
  const cursorPosition = getCursorPosition(editor);
  editor.setPosition(_objectSpread(_objectSpread({}, cursorPosition), {}, {
    lineNumber: (cursorPosition === null || cursorPosition === void 0 ? void 0 : cursorPosition.lineNumber) + 1
  }));
};
export const moveCursorToEnd = editor => {
  editor.setPosition({
    column: 9999,
    lineNumber: 9999
  });
};